import { useState } from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';

import classes from './GeneralInfo.module.css';

const GeneralInfo = props => {
  const [name, setName] = useState(props.userData.nombre);
  const [lastName, setLastName] = useState(props.userData.apellido);
  const [email, setEmail] = useState(props.userData.email);
  const [confirmEmail, setConfirmEmail] = useState('');

  const changeInputHandler = param => event => {
    if (param === 'name') {
      setName(event.target.value);
      props.updateGeneralInfo('name', event.target.value);
    } else if (param === 'lastName') {
      setLastName(event.target.value);
      props.updateGeneralInfo('lastName', event.target.value);
    } else if (param === 'email') {
      setEmail(event.target.value);
      props.updateGeneralInfo('email', event.target.value);
    } else {
      setConfirmEmail(event.target.value);
    }
    props.changeName(param, event.target.value);
    if (email !== props.userData.email) {
      props.changesHandler(false);
    } else {
      props.changesHandler(true);
    }
  };

  return (
    <>
      <TextField
        label="Nombres"
        className={classes.textField}
        placeholder="Nombres"
        value={name}
        variant="outlined"
        onChange={changeInputHandler('name')}
      />
      <TextField
        label="Apellidos"
        className={classes.textField}
        placeholder="Apellidos"
        value={lastName}
        variant="outlined"
        onChange={changeInputHandler('lastName')}
      />
      <TextField
        label="Correo electrónico"
        className={classes.textField}
        placeholder="Correo electrónico"
        value={email}
        variant="outlined"
        onChange={changeInputHandler('email')}
      />
      {email !== props.userData.email && (
        <TextField
          label="Correo electrónico"
          className={classes.textField}
          placeholder="Correo electrónico"
          value={confirmEmail}
          variant="outlined"
          onChange={changeInputHandler('confirmEmail')}
        />
      )}
    </>
  );
};

GeneralInfo.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userData: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  changeName: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  changesHandler: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  updateGeneralInfo: PropTypes.func
};

export default GeneralInfo;
